module.exports = __webpack_public_path__ + "static/home-banner3-e2959cef1ad94c7a57b7a018ddd56c76.png";